/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrecalculationSnapshotReadMetadata
 */
export interface PrecalculationSnapshotReadMetadata {
    /**
     * 
     * @type {string}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    snapshotToken?: string;
    /**
     * 
     * @type {string}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    requestedSince?: string;
    /**
     * 
     * @type {string}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    requestedUntil?: string;
    /**
     * 
     * @type {string}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    availableSince?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    availableUntil?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    requestedDayCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    publishedDayCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    complete?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    missingDays?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    generatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    redisReadCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    cacheHitCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    redisCommandCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    hGetAllCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    returnedPayloadBytes?: number;
    /**
     * 
     * @type {number}
     * @memberof PrecalculationSnapshotReadMetadata
     */
    redisReadMilliseconds?: number;
}

/**
 * Check if a given object implements the PrecalculationSnapshotReadMetadata interface.
 */
export function instanceOfPrecalculationSnapshotReadMetadata(value: object): value is PrecalculationSnapshotReadMetadata {
    return true;
}

export function PrecalculationSnapshotReadMetadataFromJSON(json: any): PrecalculationSnapshotReadMetadata {
    return PrecalculationSnapshotReadMetadataFromJSONTyped(json, false);
}

export function PrecalculationSnapshotReadMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrecalculationSnapshotReadMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'snapshotToken': json['snapshotToken'] == null ? undefined : json['snapshotToken'],
        'requestedSince': json['requestedSince'] == null ? undefined : json['requestedSince'],
        'requestedUntil': json['requestedUntil'] == null ? undefined : json['requestedUntil'],
        'availableSince': json['availableSince'] === undefined ? undefined : json['availableSince'] === null ? null : json['availableSince'],
        'availableUntil': json['availableUntil'] === undefined ? undefined : json['availableUntil'] === null ? null : json['availableUntil'],
        'requestedDayCount': json['requestedDayCount'] == null ? undefined : json['requestedDayCount'],
        'publishedDayCount': json['publishedDayCount'] == null ? undefined : json['publishedDayCount'],
        'complete': json['complete'] == null ? undefined : json['complete'],
        'missingDays': json['missingDays'] == null ? undefined : json['missingDays'],
        'generatedAt': json['generatedAt'] === undefined ? undefined : json['generatedAt'] === null ? null : json['generatedAt'],
        'redisReadCount': json['redisReadCount'] == null ? undefined : json['redisReadCount'],
        'cacheHitCount': json['cacheHitCount'] == null ? undefined : json['cacheHitCount'],
        'redisCommandCount': json['redisCommandCount'] == null ? undefined : json['redisCommandCount'],
        'hGetAllCount': json['hGetAllCount'] == null ? undefined : json['hGetAllCount'],
        'returnedPayloadBytes': json['returnedPayloadBytes'] == null ? undefined : json['returnedPayloadBytes'],
        'redisReadMilliseconds': json['redisReadMilliseconds'] == null ? undefined : json['redisReadMilliseconds'],
    };
}

export function PrecalculationSnapshotReadMetadataToJSON(json: any): PrecalculationSnapshotReadMetadata {
    return PrecalculationSnapshotReadMetadataToJSONTyped(json, false);
}

export function PrecalculationSnapshotReadMetadataToJSONTyped(value?: PrecalculationSnapshotReadMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'snapshotToken': value['snapshotToken'],
        'requestedSince': value['requestedSince'],
        'requestedUntil': value['requestedUntil'],
        'availableSince': value['availableSince'],
        'availableUntil': value['availableUntil'],
        'requestedDayCount': value['requestedDayCount'],
        'publishedDayCount': value['publishedDayCount'],
        'complete': value['complete'],
        'missingDays': value['missingDays'],
        'generatedAt': value['generatedAt'],
        'redisReadCount': value['redisReadCount'],
        'cacheHitCount': value['cacheHitCount'],
        'redisCommandCount': value['redisCommandCount'],
        'hGetAllCount': value['hGetAllCount'],
        'returnedPayloadBytes': value['returnedPayloadBytes'],
        'redisReadMilliseconds': value['redisReadMilliseconds'],
    };
}

